import React, { useEffect, useMemo, useRef, useState } from "react";
import logo from "../../assets/icons/mocionYellow.svg";
import bglogo from "../../assets/images/final.png";
import closeIcon from "../../assets/icons/deletewhite.svg";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import {
  useGetEventLeaderBoardQuery,
  useGetEventLeaderBoardTeamsQuery,
} from "../../lib/redux/services/Api";
import Table from "../../components/custom/tableWrapper/Table";
import Loader from "../../components/skeletons/Loader";
import { tableConfig } from "../../types";
import userSkeleton from "../../assets/images/user_placeholder.png";
import { useSocket } from "../../components/providers/SocketProvider";
import PrintButton from "../../components/global/PrintButton";
import ExportButton from "../../components/global/ExportButton";
import winnerIcon from "../../assets/icons/WinnerLogo.svg";
import { cn } from "../../utils/utils";
import { ArrowLeftFromLine, ArrowRightFromLine } from "lucide-react";
const EventsLeaderboard = () => {
  const { socket, subscribe, unsubscribe } = useSocket();
  const [isExpendablePlayer, setIsExpendablePlayer] = useState({
    state: false,
    index: -1,
  });
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, isFetching, isLoading, refetch } =
    useGetEventLeaderBoardQuery(id);
  console.log(data?.data?.join_type);
  useEffect(() => {
    const handleMessage = (data: any) => {
      console.log(data);
      console.log("hello");
      // Handle specific message types
      if (data[0].message.type === "mail.channel/new_message") {
        refetch();
      }
    };

    subscribe(handleMessage);

    return () => {
      unsubscribe(handleMessage);
    };
  }, [subscribe, unsubscribe, refetch, socket]);

  const columns = useMemo(() => {
    const baseColumns = [
      { title: "#", tag: "rank" },
      { title: "Team", tag: "team_name" },
      {
        title: "",
        tag: "players",
        htmlElement: () => {
          return (
            <span
              className="cursor-pointer flex gap-2 items-center w-fit"
              onClick={() => {
                setIsExpendablePlayer((prev) => {
                  if (prev.state) {
                    return {
                      state: false,
                      index: -1,
                    };
                  } else {
                    return {
                      state: true,
                      index: -1,
                    };
                  }
                });
              }}
            >
              Players{" "}
              {isExpendablePlayer.state ? (
                <ArrowLeftFromLine size={15} />
              ) : (
                <ArrowRightFromLine size={15} />
              )}
            </span>
          );
        },
      },
      { title: "Win", tag: "wins" },
      { title: "Lose", tag: "loses" },
      { title: "tie", tag: "tie" },
    ];

    const roundColumns = Array.from({ length: data?.data?.rounds }, (_, i) => ({
      title: `Round ${i + 1}`,
      tag: `Round ${i + 1}`,
    }));

    // if (searchParams.get("event_type")?.toLowerCase() == "americano")
    //   return [
    //     ...baseColumns.filter((e) => e.tag != "team_name"),
    //     ...roundColumns,
    //     { title: "Total score", tag: "total_score" },
    //   ];
    // return [...baseColumns, ...roundColumns];

    return [
      ...baseColumns.filter((e) => e.tag != "team_name"),
      ...roundColumns,
      { title: "Total score", tag: "total_score" },
    ];
  }, [data, isExpendablePlayer]);

  const config: tableConfig = {
    players: {
      columnCellClassName: isExpendablePlayer.state ? "w-[40ch]" : "",
      isCustomViewChildren: true,
      customViewChildren: (row: any, tag, setCurrentTrStyle, rowIndex) => {
        return (
          row && (
            <td
              className={cn(
                `flex-1   py-4  text-center  `,
                isExpendablePlayer.state && "w-[40ch]",
              )}
              onClick={() => {
                if (isExpendablePlayer.state) {
                  setIsExpendablePlayer({
                    state: false,
                    index: -1,
                  });
                  return;
                }
                setIsExpendablePlayer({
                  state: true,
                  index: rowIndex!,
                });
              }}
            >
              <div className="flex flex-row items-center gap-2 justify-start ">
                <img
                  loading="lazy"
                  className="max-w-14 min-w-14 h-14 object-cover rounded-full"
                  src={row?.player_images[0] || userSkeleton}
                  alt="player 1"
                />
                {data?.data?.join_type !== "Single" && (
                  <img
                    loading="lazy"
                    className="max-w-14 min-w-14 h-14 object-cover -ml-10 rounded-full"
                    src={row.player_images[1] || userSkeleton}
                    alt="player 2"
                  />
                )}
                <p className=" w-full text-start  truncate ">
                  {row.player_names}
                </p>
              </div>
            </td>
          )
        );
      },
    },
    rank: {
      columnCellClassName: "w-[50px]",
      isCustomViewChildren: true,
      customViewChildren: (row: any, tag, setCurrentTrStyle, rowIndex) => {
        return (
          <td className={cn(`w-[50px]   py-4  text-center  `)}>
            {rowIndex! + 1}
          </td>
        );
      },
    },
    total_score: {
      isCustomViewChildren: true,
      customViewChildren: (
        row: any,
        tag,
        setCurrentTrStyle,
        rowIndex,
        offsetLeft,
      ) => {
        return (
          <>
            <td className={`flex-1   py-4   text-left  font-digital`}>
              <div className="flex flex-row items-center gap-2  text-left ">
                <p className="text-left">{row?.total_score}</p>
                {rowIndex === 0 && (
                  <img loading="lazy" src={winnerIcon} alt="winner" />
                )}
              </div>
            </td>
          </>
        );
      },
    },
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bglogo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}
      className="w-full h-dvh flex flex-col  bg-white"
    >
      <div className="bg-primary h-[8vh]">
        <div className=" relative flex flex-row justify-center items-center">
          <img loading="lazy" src={logo} alt="logo" />
        </div>
      </div>

      <div className=" flex flex-row justify-around items-center text-primary dark:text-white text-4xl font-bold pt-5">
        <p className="w-full text-center">{searchParams.get("club")}</p>
        <div className="flex w-full text-center justify-center items-center gap-3">
          <h1 className="w-full">{searchParams.get("name")}</h1>
          <div className="flex flex-row justify-end mx-5  w-full gap-3">
            <PrintButton />
            <ExportButton
              fileName={`leaderboard ${id}`}
              getFunction={useGetEventLeaderBoardQuery}
              getFunctionParams={id}
              dataKey="teams"
            />
          </div>
        </div>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="fixed-table customer-table  leaderBoard-table">
          <Table
            tableClassName="mt-0 rounded-t-none printContainer "
            tbodyClassName="!bg-transparent rounded-none "
            generalCellColumnClassName=" min-w-[100px]"
            generalCellRowClassName="min-w-[100px]  text-base overflow-hidden text-left  [&:not(:first-child)]:font-digital "
            generalRowClassName="text-center [&:nth-child(1)]:bg-[#CBDB2A33]"
            generalColumnsClassName="bg-[#F3F3F3] text-[13px] text-primary dark:text-white static left"
            columnsData={
              // gameType != "Americano"
              //   ? columns
              //   : columns.filter((col) => col.tag != "teammate_id")
              columns
            }
            rowData={data?.data?.teams}
            config={config}
          />
        </div>
      )}
    </div>
  );
};

export default EventsLeaderboard;
